import { render, staticRenderFns } from "./ThoughtVerseAltWidget.vue?vue&type=template&id=50d51dda&scoped=true"
import script from "./ThoughtVerseAltWidget.vue?vue&type=script&lang=js"
export * from "./ThoughtVerseAltWidget.vue?vue&type=script&lang=js"
import style0 from "./ThoughtVerseAltWidget.vue?vue&type=style&index=0&id=50d51dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d51dda",
  null
  
)

export default component.exports